import { NavigateOptions } from "react-router";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import config from "../config/default";
import { useParamsContext } from "../contexts/params/ParamsContext";
import { IQueryParams } from "../contexts/params/IParamsContext";

export const useContextualNavigate = () => {
  const navigate = useNavigate();
  const location = window.location.href;
  const query = location.split("?")[1];

  return (to: string, options?: NavigateOptions) => {
    return navigate(`${to}${query ? `?${query}` : ""}`, options);
  };
};

export const useQueryParams = () => {
  const { params } = useParamsContext();

  const {
    payload,
    url: raw_url,
    rules,
    path,
    email,
    verification_code,
  } = params;

  const url = raw_url && new URL(raw_url).origin;

  const query = {
    payload,
    email,
    verification_code,
    ...(!payload ? { url, rules, path } : {}),
  };

  Object.keys(query).forEach((key) => (!query[key] ? delete query[key] : {}));

  const raw_query = Object.entries(query)
    .map(([k, v]) => `${k}=${v}`)
    .join("&");

  return {
    query: `${raw_query ? `?${raw_query}` : ""}`,
    queryDict: query,
  };
};

interface INavigationCookiesOptions {
  accessToken: string;
  refreshToken: string;
  redirectURL: string;
}

export const useNavigationCookies = () => {
  return (navigate: INavigationCookiesOptions) => {
    const cookies = new Cookies();

    cookies.set("accessToken", navigate.accessToken, {
      path: "/",
      domain: config.domain,
      secure: config.secureTokens,
    });

    cookies.set("refreshToken", navigate.refreshToken, {
      path: "/",
      domain: config.domain,
      secure: config.secureTokens,
    });

    document.location.href = navigate.redirectURL;
  };
};

export const useCurrentURL = () => {
  const { params } = useParamsContext();

  const queryParams = { url: "" };

  Object.entries(params).forEach(([key, value]) => {
    queryParams[key as keyof IQueryParams] = value;
  });

  return queryParams as IQueryParams;
};
